<template>
  <div class="manage-topics-roles-section">
    <div class="manage-topics-roles-section__section">
      <div class="manage-topics-roles-section__section--header">
        <h1 class="title">{{ modalTitle }}</h1>
      </div>
      <div v-if="addNewUsersPermission.includes(activeFolderOrTopicPermissions) || showSearchForModules.includes(this.module) || !activeTopic?.interest?.is_private" class="manage-topics-roles-section__section--search-users-dropdown">
        <input
          type="text"
          @focus="visibleDropdown"
          @input="handleInputChange"
          placeholder="Search name"
          class="manage-topics-roles-section__section--search-users-dropdown--input"
        />
        <div
          v-if="openDropdown"
          class="manage-topics-roles-section__section--search-users-dropdown--dropdown"
          @mousedown.stop
        >
          <template v-if="Array.from(users.values()).length === 0">
            <p class="message">
              No users found.
            </p>
          </template>
          <template v-else>
            <template v-if="searchLoader">
              <a-skeleton
                class="manage-topics-roles-section__section--search-users-dropdown--dropdown--item-skeleton"
                v-for="index in 4" :key="index"
                :title="true"
                :paragraph="{ rows: 1, }"
              ></a-skeleton>
            </template>
            <template v-else>
              <div
                v-for="(user) in Array.from(users.values())"
                :key="user?.id"
                class="manage-topics-roles-section__section--search-users-dropdown--dropdown--item"
              >
                <div @click.stop="toggleUserSelectCheck(user)" class="left-side-container">
                  <div class="image">
                    <img :src="user?.profile_picture" alt="User image" />
                  </div>
                  <p>{{ user?.name }}</p>
                </div>
                <div class="right-side-container">
                  <a-select
                    v-if="showRoleOptions"
                    class="select"
                    v-model:value="user.role"
                    :options="roleOption"
                    @change="handleSelectInUserDropDown"
                    :getPopupContainer="trigger => trigger.parentNode"
                    dropdownClassName="bottomRightSelect"
                  ></a-select>
                  <a-checkbox v-model:checked="user.isChecked" @change="selectUser(user)"/>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
      <!-- selected users -->
      <div v-if="addNewUsersPermission.includes(activeFolderOrTopicPermissions) || showSelectMembers.includes(module) || !activeTopic?.interest?.is_private" class="manage-topics-roles-section__section--active-admin">
        <div class="header">
          <h1 class="title">{{ this.module === 'shareFeedPost' ? 'Users:' : 'Selected Members:' }} {{Array.from(selectedUsers.values()).length}}</h1>
        </div>
        <div class="body">
          <div class="add-user-card-container">
            <template v-if="Array.from(selectedUsers.values()).length == 0">
              <p class="message">{{ this.module === 'shareFeedPost' ? 'No users selected' : 'No members selected' }}</p>
            </template>
            <template v-else>
              <div v-for="user in Array.from(selectedUsers.values())" :key="user?.id" class="add-user-card">
                <div class="add-user-card__image">
                  <img
                    :src="user?.profile_picture"
                    alt="profile_picture"
                  />
                </div>
                <div class="add-user-card__content">
                  <div class="add-user-card__content--name">
                    <h1>{{user?.name}}</h1>
                  </div>
                  <a-select
                    v-if="showRoleOptions"
                    class="add-user-card__content--select"
                    v-model:value="user.role"
                    :options="roleOption"
                  ></a-select>
                  <button @click.stop="removeUserLocally(user)" class="add-user-card__content--close-btn" :class="{'float-left': !showRoleOptions}">
                    <i class="icon icon-add_plus"></i>
                  </button>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- selected users -->

      <!-- Active and Pending users -->
      <div v-if="showActiveOrPendingUserForModules.includes(module) ||(module === 'InviteTopicCollaboration' && activeTopic?.interest?.is_private)" class="manage-topics-roles-section__section--active-admin">
        <div class="header">
          <h1 class="title">Active And Pending Members: {{Array.from(activeOrPendingUsers.values()).length}}</h1>
        </div>
        <div class="body">
          <div class="add-user-card-container">
            <template v-if="Array.from(activeOrPendingUsers.values()).length == 0">
              <p class="message">No active or pending members found.</p>
            </template>
            <template v-else>
              <p class="title">Admins</p>
              <template v-if="activeAndPendingAdmins.length ==  0"> 
                <p class="message">No admins found</p>
              </template>
              <template v-else>
                <div v-for="user in activeAndPendingAdmins" :key="user?.id" class="add-user-card">
                  <div class="add-user-card__image">
                    <img
                      :src="user?.profile_picture"
                      alt="profile_picture"
                    />
                  </div>
                  <div class="add-user-card__content">
                    <div class="add-user-card__content--name">
                      <h1>{{user?.name}}</h1>
                      <p v-if="user?.status === 'pending'" :class="{pending : 'pending'}">Pending</p>
                      <p v-if="user?.status === 'active'" :class="{active : 'active'}">Active</p>
                    </div>
                    <a-select
                      v-if="showRoleOptions"
                      :disabled="(loggedInUserDetails?.id !== user?.created_by || user?.created_by === user?.id)"
                      class="add-user-card__content--select"
                      v-model:value="user.role"
                      :options="roleOption"
                      @change="(event) => {handleChange(user)}"
                    ></a-select>
                    <button v-if='user?.created_by !== user?.id && loggedInUserDetails?.id !== user?.id && removeAdminPermissions.includes(activeFolderOrTopicPermissions) && updateRoleOrRemoveEditorModulePermission.includes(this.module)' @click.stop="removeUserRemotely(user)" class="add-user-card__content--close-btn">
                      <i class="icon icon-add_plus"></i>
                    </button>
                  </div>
                </div>
              </template>

              <p class="title">Editors</p>
              <template v-if="activeAndPendingEditors.length ==  0"> 
                <p class="message">No editors found</p>
              </template>
              <template v-else>
                <div v-for="user in activeAndPendingEditors" :key="user?.id" class="add-user-card">
                  <div class="add-user-card__image">
                    <img
                      :src="user?.profile_picture"
                      alt="profile_picture"
                    />
                  </div>
                  <div class="add-user-card__content">
                    <div class="add-user-card__content--name">
                      <h1>{{user?.name}}</h1>
                      <p v-if="user?.status === 'pending'" :class="{pending : 'pending'}">Pending</p>
                      <p v-if="user?.status === 'active'" :class="{active : 'active'}">Active</p>
                    </div>
                    <a-select
                      v-if="showRoleOptions"
                      :disabled="loggedInUserDetails?.id === user?.id || !updateEditorRolePermissions.includes(activeFolderOrTopicPermissions)"
                      class="add-user-card__content--select"
                      v-model:value="user.role"
                      :options="roleOption"
                      @change="(event) => {handleChange(user)}"
                    ></a-select>
                    <button v-if='user?.created_by !== user?.id && loggedInUserDetails?.id !== user?.id && removeEditorPermissions.includes(activeFolderOrTopicPermissions) && updateRoleOrRemoveEditorModulePermission.includes(this.module)' @click.stop="removeUserRemotely(user)" class="add-user-card__content--close-btn">
                      <i class="icon icon-add_plus"></i>
                    </button>
                  </div>
                </div>
              </template>

              <p class="title">Contributors</p>
              <template v-if="activeAndPendingContributors.length == 0"> 
                <p class="message">No contributors found</p>
              </template>
              <template v-else>
                <div v-for="user in activeAndPendingContributors" :key="user?.id" class="add-user-card">
                  <div class="add-user-card__image">
                    <img
                      :src="user?.profile_picture"
                      alt="profile_picture"
                    />
                  </div>
                  <div class="add-user-card__content">
                    <div class="add-user-card__content--name">
                      <h1>{{user?.name}}</h1>
                      <p v-if="user?.status === 'pending'" :class="{pending : 'pending'}">Pending</p>
                      <p v-if="user?.status === 'active'" :class="{active : 'active'}">Active</p>
                    </div>
                    <a-select
                      v-if="showRoleOptions"
                      :disabled="loggedInUserDetails?.id === user?.id || !updateContributorRolePermissions.includes(activeFolderOrTopicPermissions)"
                      class="add-user-card__content--select"
                      v-model:value="user.role"
                      :options="roleOption"
                      @change="(event) => {handleChange(user)}"
                    ></a-select>
                    <button v-if='user?.created_by !== user?.id && loggedInUserDetails?.id !== user?.id && removeContributorPermissions.includes(activeFolderOrTopicPermissions) && updateRoleOrRemoveContributorModulePermission.includes(this.module)' @click.stop="removeUserRemotely(user)" class="add-user-card__content--close-btn">
                      <i class="icon icon-add_plus"></i>
                    </button>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
      <!-- Active and Pending users -->
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props:{
    userOptions:{
      type: Array,
      default:() =>([])
    },
    module: {
      type: String,
      default: () => ('AddTopicModule')
    },
    preSelectedUsers:{
      type:Array,
      default: () =>([])
    },
    topicManaged:{
      type: Object,
      default: () => ({})
    },
    topicType:{
      type: String,
      default: () => ('private')
    },
    searchLoader:{
      type: Boolean,
      default : () => (false)
    },
  },
  emits:['searchUser', 'pendingOrUpdateUsers', 'fetchSelectedUser', 'removeUser'],
  data() {
    return {
      AdminOptions: [
        {
          label: 'Admin',
          value: 'admin'
        },
        {
          label: 'Editor',
          value: 'editor'
        },
        {
          label: 'Contributor',
          value: 'contributor'
        }
      ],
      EditorOptions: [
        {
          label: 'Editor',
          value: 'editor'
        },
        {
          label: 'Contributor',
          value: 'contributor'
        }
      ],
      openDropdown: false,
      users: new Map(),
      selectedUsers:new Map(),
      activeOrPendingUsers: new Map(),
      updatedUsers: new Map(),
      removeAdminPermissions: ['admin'],
      removeEditorPermissions: ['admin', 'editor'],
      removeContributorPermissions: ['admin', 'editor'],
      updateAdminRolePermissions: ['admin'],
      updateEditorRolePermissions: ['admin'],
      updateContributorRolePermissions: ['admin', 'editor'],
      addNewUsersPermission: ['admin'],
      updateRoleOrRemoveEditorModulePermission : ['TopicManagement', 'AddTopicModule', 'folderInvite'],
      updateRoleOrRemoveAdminModulePermission : ['TopicManagement', 'AddTopicModule', 'folderInvite'],
      updateRoleOrRemoveContributorModulePermission : ['TopicManagement', 'AddTopicModule', 'folderInvite'],
      showSearchForModules: ['AddTopicModule', 'shareFeedPost', 'folderInvite'],
      showActiveOrPendingUserForModules: ['TopicManagement', 'folderInvite'],
      showSelectMembers: ['TopicManagement' , 'AddTopicModule', 'shareFeedPost', 'folderInvite']
      
    };
  },
  computed:{
    ...mapGetters({
      activeTopic: 'discover/getTopic',
      activeFolder: 'folders/activeFolder'
    }),
    loggedInUserDetails() {
      return this.$store.getters["profile/userInformation"];
    },
    activeAndPendingAdmins(){
      return Array.from(this.activeOrPendingUsers.values()).filter(user=>user?.role === 'admin')
    },
    activeAndPendingEditors(){
      return Array.from(this.activeOrPendingUsers.values()).filter(user=>user?.role === 'editor')
    },
    activeAndPendingContributors(){
      return Array.from(this.activeOrPendingUsers.values()).filter(user=>user?.role === 'contributor')
    },
    roleOption(){
      return this.activeFolderOrTopicPermissions === 'editor' && this.module === 'TopicManagement' ? this.EditorOptions : this.AdminOptions
    },
    showRoleOptions(){
      return this.module === 'TopicManagement' || ( this.module === 'AddTopicModule' && this.topicType === 'private') || (this.module === 'InviteTopicCollaboration' && this.topicType === 'private') || this.module === 'folderInvite'
    },
    modalTitle(){
      if (this.module === 'shareFeedPost')
        return 'Share Post via Glocal'
      else if (this.module === 'folderInvite')
        return '' // no label for folder invite
      else
        return 'Manage Topic Members'
    },
    activeFolderOrTopicPermissions(){
      // console.log("HEEERE", this.activeFolder)
      if (this.module === 'folderInvite'){
        return this.activeFolder?.permission
      }else return this.activeTopic?.permission
    }
  },
  watch:{
    userOptions:{
      handler(options){
        this.users = this.serializeData(options)
      }, 
      immediate:true
    },
    preSelectedUsers:{
      handler(users){
        if (users && Array.isArray(users))
          this.activeOrPendingUsers = this.serializeData(users)
      }, 
      immediate:true
    },
  },
  mounted(){

    this.emitter.on('clear-manage-topic-roles', ()=>{
      this.clearAll()
    })

    this.emitter.on('reset-manage-topic-roles-users', ()=>{
      this.resetUserArray()
      this.clearSelectedUsers()
    })

    this.emitter.on('remove-existing-user-manage-topic-roles', (user)=>{
      this.activeOrPendingUsers.delete(user?.id)
      this.updatedUsers.delete(user?.id)
      this.sendData()
    })
    
  },
  methods: {
    visibleDropdown() {
      setTimeout(() => {
        this.openDropdown = true;
      }, 200);
    },
    hideDropdown(){
      this.openDropdown = false
    },
    selectUser(user){
      if (user?.isChecked)
        this.selectedUsers.set(user?.id, user)
      else
        this.selectedUsers.delete(user?.id)   

      this.sendData()
    },
    serializeData(userOptions){
      // alphabetically sorting
      const sortedOptions = this.sortUsersAlphabetically(userOptions)
      return new Map(sortedOptions.map(user=>[user?.id, {
        ...user,
        name: user?.label || user?.full_name,
        profile_picture: user?.icon || user?.profile_picture,
        role: user?.role ?? 'contributor'
      }]))
    },
    removeUser(user){
      this.module === 'AddTopicModule' ? this.removeUserLocally(user) : this.removeUserRemotely(user)
    },
    removeUserLocally(user){
      this.selectedUsers.delete(user?.id)
      this.users.set(user?.id, {...user, isChecked: false})
      this.sendData()
    },
    removeUserRemotely(user){
      this.$emit('removeUser', user)
    },
    sendData(){
      this.$emit('fetchSelectedUser', Array.from(this.selectedUsers.values()))
      this.$emit('pendingOrUpdateUsers', Array.from(this.updatedUsers.values()))
    },
    clearAll(){
      this.users =  new Map()
      this.selectedUsers = new Map()
      this.activeOrPendingUsers = new Map()
      this.updatedUsers = new Map()
    },
    handleChange(user){
      this.updatedUsers.set(user?.id, user)
      this.sendData()
    },
    handleSelectInUserDropDown(){
      this.openDropdown = true
    },
    toggleUserSelectCheck(user){
        const updatedUser = {...user, isChecked: user?.isChecked ? false : true} 
        this.users.set(user?.id, updatedUser)
        this.selectUser(updatedUser)
    },
    clearSelectedUsers(){
      this.selectedUsers = new Map()
      this.activeOrPendingUsers = new Map()
      this.updatedUsers = new Map()
    },
    resetUserArray(){
      Array.from( this.users.values()).forEach(user=>{
        this.users.set(user?.id, {...user, isChecked:false})
      }) 
    },
    handleInputChange(e){
      this.debounce(()=>{
          this.$emit('searchUser', e.target.value)
      }, 500)
    },
    debounce(method, timer) {
      if (this.$_debounceTimer !== null) {
        clearTimeout(this.$_debounceTimer);
      }
      this.$_debounceTimer = setTimeout(() => {
        method();
      }, timer);
    },
    sortUsersAlphabetically(userArray=[]){
      userArray.sort((user1, user2)=>{
        if (user1?.label)
          if (user1?.label.toLowerCase() > user2?.label.toLowerCase())
            return 1
          else return -1
        else if (user1?.full_name)
          if (user1?.full_name.toLowerCase() > user2?.full_name.toLowerCase())
            return 1
          else return -1
        else return -1
      }) 
      return userArray
    }
  },
};
</script>

<style lang="scss">
.manage-topics-roles-section {
  margin-top: 3rem;
  &__section {
    padding-bottom: 2rem;
    margin-bottom: 3rem;
    border-bottom: 1px solid $color-dark-grey-5;
    &--msg {
      color: red;
    }
    &--header {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 1.2rem;
      .title {
        font-size: 1.6rem;
        font-family: $font-primary-medium;
        line-height: 2.2rem;
        margin-bottom: 0;
        color: $color-black;
      }
    }
    &--search-users-dropdown {
      position: relative;
      &--input {
        border-radius: 0.5rem !important;
        font-size: 1.4rem;
        border: 1px solid $color-dark-grey-4;
        font-family: $font-primary;
        width: 100%;
        height: 4rem;
        padding: 1rem;
        outline: none;
        color: $color-black;
        &::placeholder {
          color: $color-placeholder;
        }
      }
      &--dropdown {
        position: absolute;
        width: 100%;
        background-color: $color-white;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
        border-end-end-radius: 0.5rem;
        border-end-start-radius: 0.5rem;
        height: 20rem;
        overflow-y: auto;
        z-index: 2;
        overflow-x: hidden;
        top: 4rem;
        .message {
          cursor: default;
          font-size: 1.4rem;
          font-family: $font-primary;
          line-height: normal;
          margin: 1.8rem 0;
          color: $color-black;
          text-align: center;
          opacity: 0.8;
        }
        &--item {
          padding: 1rem !important;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          border-bottom: 1px solid $color-dark-grey-5;
          cursor: pointer;
          gap: 1rem;
          &:last-child {
            border-bottom: none;
          }
          .left-side-container {
            display: flex;
            align-items: center;
            gap: 1rem;
            .image {
              width: 3rem;
              height: 3rem;
              border-radius: 100%;
              overflow: hidden;
              img {
                background-color: #80808040;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            p {
              margin: 0 !important;
              padding: 0 !important;
              font-size: 1.6rem;
              font-family: $font-primary-medium;
              line-height: normal;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1; /* number of lines to show */
              line-clamp: 1;
              -webkit-box-orient: vertical;
            }
          }
          .right-side-container {
            margin-left: auto;
            display: flex;
            align-items: center;
            gap: 1rem;
            .select {
              box-shadow: none;
              .ant-select-selector {
                height: 2.5rem !important;
                background-color: $color-white;
                border: none;
                font-size: 1.4rem;
                line-height: normal;
                color: $color-black;
                padding: 0;
                box-shadow: none !important;
                border-radius: 0.5rem !important;
                font-family: $font-primary-medium;
                .ant-select-selection-search {
                  right: 2.6rem;
                  .ant-select-selection-search-input {
                    height: 100%;
                  }
                }
                .ant-select-selection-item {
                  font-size: 1.2rem;
                  padding-right: 1.7rem;
                  line-height: normal;
                }
              }
              .ant-select-arrow {
                right: 0;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                .anticon {
                  color: $color-black;
                  font-size: 1.1rem;
                }
              }
            }
            .ant-checkbox-wrapper {
              margin-left: auto;
              font-size: 1.6rem;
              font-family: $font-secondary;
              width: fit-content;
              margin-bottom: 0;
              line-height: 2rem;

              .ant-checkbox {
                .ant-checkbox-inner {
                  border: 0.18rem solid rgba(128, 128, 128, 0.377);
                  height: 1.8rem;
                  width: 1.8rem;
                  border-radius: 0;
                  &::after {
                    width: 0.6rem;
                    height: 0.9rem;
                  }
                }

                .ant-checkbox-input {
                  width: fit-content;
                  height: 100% !important;
                }
              }
            }
            .ant-checkbox-wrapper-checked {
              .ant-checkbox-checked {
                .ant-checkbox-inner {
                  background-color: $color-primary;
                  border-color: $color-primary;
                  height: 1.8rem;
                  width: 1.8rem;
                  border-radius: 0;
                }
              }
            }
          }
        }
        &--item-skeleton {
          padding: 1rem;
          border-bottom: 1px solid $color-dark-grey-5;
          &:last-child {
            border-bottom: none;
          }
          .ant-skeleton-content {
            display: flex;
            align-items: center;
            gap: 1rem;
            .ant-skeleton-title {
              width: 3rem !important;
              height: 3rem;
              border-radius: 100% !important;
              margin: 0;
            }
            .ant-skeleton-paragraph {
              width: calc(100% - 4rem) !important;
              margin: 0;
              li {
                width: 100% !important;
                height: 2rem;
              }
            }
          }
        }
      }
      &--dropdown::-webkit-scrollbar-track {
        background-color: $color-white;
      }
      &--dropdown::-webkit-scrollbar {
        width: 4px;
        background-color: $color-white;
        border-radius: 3rem;
      }
      &--dropdown::-webkit-scrollbar-thumb {
        background-color: $color-primary;
        border-radius: 3rem;
      }
    }
    &--active-admin {
      margin-top: 2rem;
      .header {
        margin-bottom: 1.8rem;
        .title {
          font-size: 1.4rem;
          font-family: $font-primary-medium;
          line-height: 2.2rem;
          margin-bottom: 1.8rem;
          color: $color-black;
          opacity: 0.6;
        }
      }
      .body {
        .message {
          font-size: 1.4rem;
          text-align: center;
          font-family: $font-primary;
          display: block;
          margin: 0 auto 2rem;
          opacity: 0.8;
        }
        .title {
          font-size: 1.4rem;
          font-family: $font-primary-medium;
          line-height: 2.2rem;
          margin-bottom: 0rem;
          margin-top: 0.5rem;
          color: $color-black;
        }
      }
      .add-user-card-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        .add-user-card {
          display: flex;
          align-items: center;
          gap: 0.8rem;
          width: 100%;
          &__image {
            width: 4rem;
            height: 4rem;
            overflow: hidden;
            border-radius: 100%;
            img {
              background-color: #80808040;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          &__content {
            display: flex;
            align-items: center;
            gap: 0.8rem;
            width: calc(100% - 5.3rem);
            &--name {
              display: flex;
              align-items: flex-start;
              flex-direction: column;
              gap: 0.4rem;
              h1 {
                font-size: 1.6rem;
                font-family: $font-primary-medium;
                line-height: normal;
                margin-bottom: 0;
                color: $color-black;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1; /* number of lines to show */
                line-clamp: 1;
                -webkit-box-orient: vertical;
              }
              p {
                font-size: 1rem;
                line-height: normal;
                height: 1.7rem;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 0.9rem;
                border-radius: 1rem;
                margin-bottom: 0;
                font-family: $font-primary;
              }
              .pending {
                background-color: #ec424226;
                color: #ec4242;
              }
              .active {
                background-color: #0080003b;
                color: green;
              }
            }
            &--select {
              margin-left: auto;
              box-shadow: none;
              .ant-select-selector {
                height: 3rem !important;
                background-color: $color-primary;
                border: none;
                font-size: 1.4rem;
                line-height: normal;
                color: $color-white;
                padding: 0 1.5rem;
                box-shadow: none !important;
                border-radius: 0.5rem !important;
                font-family: $font-primary-medium;
                .ant-select-selection-search {
                  right: 2.6rem;
                  .ant-select-selection-search-input {
                    height: 100%;
                  }
                }
                .ant-select-selection-item {
                  font-size: 1.2rem;
                  padding-right: 2rem;
                  line-height: normal;
                }
              }
              .ant-select-arrow {
                right: 1.5rem;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                .anticon {
                  color: $color-white;
                  font-size: 1.1rem;
                }
              }
            }
            .float-left{
              margin-left: auto
            }

            &--close-btn {
              height: 3rem;
              width: 3rem;
              display: flex;
              align-items: center;
              justify-content: center;
              border: none;
              outline: none;
              border-radius: 0.5rem !important;
              background-color: rgb(239, 239, 239);
              cursor: pointer;
              .icon {
                display: block;
                transform: rotate(45deg);
                font-size: 1.3rem;
                color: $color-black;
                line-height: normal;
              }

            }
          }
        }
      }
    }
  }
}
.bottomRightSelect {
  right: 0 !important;
  left: auto !important;
}
</style>
